import { Dayjs } from "dayjs";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { MONTHLY_EXPENSE_CLOSE_MENU_TITLE } from "../DailyExpense/constants";
import DailyExpenseStatusChip from "../DailyExpense/DailyExpenseStatusChip";
import ExpenseMonthPicker from "../DailyExpense/ExpenseMonthPicker";
import { CloseWrite } from "./useMonthlyExpenseClose";

interface CloseHeaderProps {
  month: Dayjs;
  /** "ประมาณการ ตุลาคม 2026"; absent until the month is read. */
  estimateText: string | null;
  isClosed: boolean | null;
  canEdit: boolean;
  canClose: boolean;
  hasChanges: boolean;
  pendingWrite: CloseWrite | null;
  onMonthChange: (value: Dayjs | null) => void;
  onSave: () => void;
  onClose: () => void;
}

/** เดือน → ประมาณการ เดือนถัดไป, the month's status, บันทึกร่าง and ส่งและปิดเดือน. */
export default function CloseHeader({
  month,
  estimateText,
  isClosed,
  canEdit,
  canClose,
  hasChanges,
  pendingWrite,
  onMonthChange,
  onSave,
  onClose,
}: Readonly<CloseHeaderProps>) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap">
      <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
        <Typography variant="h6" fontWeight={600}>
          {MONTHLY_EXPENSE_CLOSE_MENU_TITLE}
        </Typography>
        <ExpenseMonthPicker value={month} onChange={onMonthChange} />
        {estimateText && (
          <Typography variant="body2" color="text.secondary">
            → {estimateText}
          </Typography>
        )}
        {isClosed !== null && (
          <DailyExpenseStatusChip
            kind={isClosed ? "LOCKED" : "DRAFT"}
            label={isClosed ? "ส่งและปิดเดือนแล้ว" : undefined}
          />
        )}
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        {canEdit && !canClose && (
          <Typography variant="caption" color="text.secondary">
            ส่งและปิดเดือนได้หลังสิ้นเดือนแล้ว
          </Typography>
        )}
        {canEdit && (
          <Button
            variant="outlined"
            disabled={!hasChanges || pendingWrite !== null}
            loading={pendingWrite === "SAVE"}
            onClick={onSave}
          >
            บันทึกร่าง
          </Button>
        )}
        {canClose && (
          <Button variant="contained" disabled={pendingWrite !== null} onClick={onClose}>
            ส่งและปิดเดือน
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
